import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";

export default function ProtectedRoute({ children, adminOnly, fullAdminOnly }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="overline">Memuat...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // fullAdminOnly = only role 'admin' (not admin_kantor). Used for Layout Editor + Library TTD.
  if (fullAdminOnly && user.role !== "admin")
    return <Navigate to="/" replace />;
  // adminOnly = either 'admin' OR 'admin_kantor'.
  if (adminOnly && user.role !== "admin" && user.role !== "admin_kantor")
    return <Navigate to="/loading" replace />;
  return <AppLayout>{children}</AppLayout>;
}
